module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-litho-limestone-oyster.ca567551.jpg";